"use client";

import { Pagination } from "@/components/ui";

export function PublicListingPagination({
  currentPageZeroBased,
  totalPages,
  totalCount,
  rangeStart,
  rangeEnd,
  onPrev,
  onNext,
  ariaLabel,
}: {
  currentPageZeroBased: number;
  totalPages: number;
  totalCount: number;
  rangeStart: number;
  rangeEnd: number;
  onPrev: () => void;
  onNext: () => void;
  ariaLabel: string;
}) {
  return (
    <Pagination
      currentPage={currentPageZeroBased + 1}
      totalPages={totalPages}
      canGoPrev={currentPageZeroBased > 0}
      canGoNext={currentPageZeroBased < totalPages - 1}
      onPrev={onPrev}
      onNext={onNext}
      totalCount={totalCount}
      rangeStart={rangeStart}
      rangeEnd={rangeEnd}
      ariaLabel={ariaLabel}
      mt={6}
    />
  );
}
